module.exports = __webpack_public_path__ + "static/media/member3.026fddbe.jpg";